/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 救急隊員の役職
 */
export type EmsTeamMemberPositionEnum =
  (typeof EmsTeamMemberPositionEnum)[keyof typeof EmsTeamMemberPositionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmsTeamMemberPositionEnum = {
  LEADER: 'LEADER',
  SUB_LEADER: 'SUB_LEADER',
  MEMBER: 'MEMBER',
} as const;
